declare global {
  interface Window {
    __ENV__?: Record<string, string>;
  }
}

export const runtimeConfig = {
  ...(import.meta.env || {}),
  ...(window.__ENV__ || {}),
};
